/**
 * Coexistence C4 (27-oct-2026): cómo se le cuenta al cliente, en Canales, que su número en
 * coexistence está `desconectado` o `en_reconexion` según el `account_update` de Meta.
 *
 * El ESCRITOR es `functions/integrations/coexistence/cuenta.js` (`atenderAccountUpdate`): deja
 * `estado: 'desconectado'` + `desconexion { evento, reason, initiatedBy, en }`, o `estado:
 * 'en_reconexion'` + `reconexion { evento, en }`. Los literales de estado son los suyos; el test
 * `badgeNumeroDesconectadoC4` compara los dos lados.
 *
 * Decisión de Rodrigo (27-oct): el motivo en lenguaje simple por `reason`, es/en/pt; motivo
 * desconocido → texto genérico + el código. Una decisión con más de dos ramas va en una
 * función pura, fuera del componente (CLAUDE.md d74).
 */
export const ESTADO_DESCONECTADO = 'desconectado';
export const ESTADO_EN_RECONEXION = 'en_reconexion';
export const ESTADOS_NO_OPERATIVOS = [ESTADO_DESCONECTADO, ESTADO_EN_RECONEXION];

/** Motivos documentados por Meta (disconnection_info.reason). Cada uno tiene su texto en `channels.json`. */
export const MOTIVOS_CONOCIDOS = ['PRIMARY_INACTIVITY', 'COMPANION_INACTIVITY', 'ACCOUNT_DISCONNECTED', 'BUSINESS_DOWNGRADE', 'CHANGE_NUMBER', 'USER_RE_REGISTERED'];

export function esNumeroNoOperativo(num) {
  return !!num && ESTADOS_NO_OPERATIVOS.includes(num.estado);
}

/**
 * Lo que Canales pinta para un número no operativo, como claves de i18n (el componente sólo
 * llama a `t`). `null` si el número no está en uno de los dos estados.
 *   badge   → `whatsappApi.statusDisconnected` | `whatsappApi.statusReconnecting`
 *   motivo  → `whatsappApi.desconexion.<REASON>` (conocido), `…ACCOUNT_DISCONNECTED_SYSTEM` cuando
 *             Meta lo inició, `…desconocido` con `{ codigo }`, o `whatsappApi.reconexionEnCurso`.
 */
export function textoDeNumeroNoOperativo(num) {
  if (!esNumeroNoOperativo(num)) return null;
  if (num.estado === ESTADO_EN_RECONEXION) {
    return { badge: 'whatsappApi.statusReconnecting', motivo: 'whatsappApi.reconexionEnCurso', codigo: null, estado: num.estado };
  }
  const d = num.desconexion || {};
  const reason = typeof d.reason === 'string' && d.reason ? d.reason : null;
  const iniciadoPorMeta = String(d.initiatedBy || '').toUpperCase() === 'SYSTEM';
  let motivo;
  if (reason === 'ACCOUNT_DISCONNECTED' && iniciadoPorMeta) motivo = 'whatsappApi.desconexion.ACCOUNT_DISCONNECTED_SYSTEM';
  else if (reason && MOTIVOS_CONOCIDOS.includes(reason)) motivo = `whatsappApi.desconexion.${reason}`;
  else motivo = 'whatsappApi.desconexion.desconocido';
  return { badge: 'whatsappApi.statusDisconnected', motivo, codigo: reason || (d.evento ? String(d.evento) : 'SIN_MOTIVO'), estado: num.estado };
}
